import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class VdDividerService {
    constructor() { }
}
VdDividerService.ɵfac = function VdDividerService_Factory(t) { return new (t || VdDividerService)(); };
VdDividerService.ɵprov = i0.ɵɵdefineInjectable({ token: VdDividerService, factory: VdDividerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdDividerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class VdDividerComponent {
    constructor() { }
    ngOnInit() {
        // this.style = {"width":'500px','border-style':'dashed','border-color':'black'}
        //this.switch_field = true;
        // this.subText =  this.sublabel;
    }
    ngOnChanges() {
        // console.log('child Label', this.sublabel);
        // this.subText =  this.sublabel;
    }
}
VdDividerComponent.ɵfac = function VdDividerComponent_Factory(t) { return new (t || VdDividerComponent)(); };
VdDividerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdDividerComponent, selectors: [["vd-divider"]], inputs: { inputParams: "inputParams" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "ngStyle"]], template: function VdDividerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "hr", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngStyle", ctx.inputParams.style);
    } }, directives: [i1.NgStyle], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdDividerComponent, [{
        type: Component,
        args: [{
                selector: 'vd-divider',
                templateUrl: 'vd-divider.component.html',
                styleUrls: ['vd-divider.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { inputParams: [{
            type: Input
        }] }); })();

class VdDividerModule {
}
VdDividerModule.ɵfac = function VdDividerModule_Factory(t) { return new (t || VdDividerModule)(); };
VdDividerModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdDividerModule });
VdDividerModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdDividerModule, { declarations: [VdDividerComponent], imports: [PrimengLibraryModule], exports: [VdDividerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdDividerModule, [{
        type: NgModule,
        args: [{
                declarations: [VdDividerComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [VdDividerComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-divider
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdDividerComponent, VdDividerModule, VdDividerService };
//# sourceMappingURL=vd-divider.js.map
